<template>
  <div>
    <sc-form autocomplete="off" ref="credentialsForm">
      <template slot="fields" slot-scope="{ fields }">
        <main class="finishContent">
          <h1 class="title">Integração concluida com sucesso</h1>

          <span class="spanCheck">&check;</span>

          <p class="feedback">Seu feedback é fundamental! Por favor, participe da pesquisa sobre esse processo clicando
            <a target="blank" href="https://docs.google.com/forms/d/e/1FAIpQLScI3zUeSWPTCDtWkkKM_jm3VSgeRFsxHUHjvyxGF7z0SYp2VQ/viewform">aqui</a>
          </p>
        </main>
      </template>

      <template slot="actions" slot-scope="{ isValid }">
        <sc-button
          id="buttonFinish"
          class="finishIntegration"
          text="Finalizar"
          theme="primary"
          @click="finishProcess"
          type="submit"
        />
      </template>
    </sc-form>
  </div>
</template>


<script>
  import {
    ScButton,
    ScForm,
  } from '@intelipost-js/secure-components';

  export default {
    name: 'sc-finished',
    methods: {
      finishProcess() {
        this.$router.push({ name: 'iplink-store' });
      },
    },
    components: {
      ScButton,
      ScForm,
    },
  };
</script>

<style scoped>
  .finishContent {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 30px;
    height: 30vh;
  }
  .spanCheck{
    width: 50px;
    height: 50px;
    background: #09a83d;
    border-radius: 50%;
    text-align: center;
    color: white;
    font-weight: bold;
    font-size: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .title{
    font-size: 1.5rem;
  }
  .feedback {
    font-size: 1.2rem;
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-finished/ScFinished.vue